var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.25C0.223858 0.25 0 0.473858 0 0.75C0 1.02614 0.223858 1.25 0.5 1.25H1.38965C1.46245 1.25 1.5334 1.27291 1.59245 1.31547C1.65151 1.35804 1.69568 1.41811 1.71869 1.48718L3.36719 6.43359C3.44039 6.65321 3.4497 6.88967 3.39355 7.11426L3.25781 7.6582C3.05864 8.45489 3.67879 9.25 4.5 9.25H10.5C10.7761 9.25 11 9.02614 11 8.75C11 8.47386 10.7761 8.25 10.5 8.25H4.5C4.30531 8.25 4.18032 8.09025 4.22754 7.90137L4.32991 7.49251C4.34725 7.42324 4.38725 7.36174 4.44355 7.31781C4.49984 7.27387 4.56921 7.25 4.64062 7.25H10C10.2153 7.25011 10.4065 7.11242 10.4746 6.9082L11.8076 2.9082C11.9156 2.58431 11.6744 2.24984 11.333 2.25H3.27734C3.20454 2.25 3.13359 2.22709 3.07453 2.18453C3.01548 2.14196 2.97131 2.08189 2.94829 2.01283L2.47461 0.591797C2.40648 0.387577 2.21529 0.249888 2 0.25H0.5ZM4 9.75C3.44772 9.75 3 10.1977 3 10.75C3 11.3023 3.44772 11.75 4 11.75C4.55228 11.75 5 11.3023 5 10.75C5 10.1977 4.55228 9.75 4 9.75ZM10 9.75C9.44771 9.75 9 10.1977 9 10.75C9 11.3023 9.44771 11.75 10 11.75C10.5523 11.75 11 11.3023 11 10.75C11 10.1977 10.5523 9.75 10 9.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e077c50b578f890c646bbb050a657dc6.svg";
export { ForwardRef as ReactComponent };